import { withAddressSplitAlgorithmTrackPage } from '@/bizComponents/AddressAutoSplit/AddressSplitAlgorithmTrack'
import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    name: 'addressbook',
    path: '/addressbook',
    component: withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/AddressBook/List')),
    exact: true,
    main: true,
    permissionCode: 'settings:addressbook',
  },
  {
    name: 'addressbook',
    path: '/addressbook/edit',
    component: withAddressSplitAlgorithmTrackPage(
      withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/AddressBook/Create')),
      'addressEdit'
    ),
    exact: true,
    permissionCode: 'settings:addressbook',
  },
  {
    name: 'addressbook',
    path: '/addressbook/create',
    component: withAddressSplitAlgorithmTrackPage(
      withAsync(() => import(/* webpackChunkName: "addressBook" */ '@/containers/AddressBook/Create')),
      (props) => {
        const { search } = props?.location || {}
        return search.indexOf('addressNo=') !== -1 ? 'addressEdit' : 'addressCreate'
      }
    ),
    exact: true,
    permissionCode: 'settings:addressbook',
  },
]

export default routes
